(() => {
  const normalise = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  const split = (value) => String(value || '').split(/[\n,]+/).map(normalise).filter(Boolean);

  function registry() {
    const entries = [];
    document.querySelectorAll('[data-brand-logo-library]').forEach((node) => {
      try {
        JSON.parse(node.textContent || '[]').forEach((item) => {
          if (!item.url || !item.key) return;
          item.keys = new Set([normalise(item.key), ...split(item.aliases)]);
          item.handles = new Set(split(item.products));
          entries.push(item);
        });
      } catch (error) {
        console.warn('Brand logo library could not be read.', error);
      }
    });
    return entries;
  }

  function applyLogos(root = document) {
    const entries = registry();
    if (!entries.length) return;

    root.querySelectorAll('.arena-product-brand[data-brand-key]').forEach((brand) => {
      const brandKey = normalise(brand.dataset.brandKey || brand.getAttribute('aria-label'));
      const productHandle = normalise(brand.dataset.productHandle);
      const match = entries.find((item) => productHandle && item.handles.has(productHandle))
        || entries.find((item) => item.keys.has(brandKey));
      if (!match) return;

      let image = brand.querySelector('img');
      if (!image) {
        brand.textContent = '';
        image = document.createElement('img');
        brand.appendChild(image);
      }
      brand.classList.remove('arena-product-brand--wordmark');
      brand.setAttribute('aria-label', match.name);
      image.className = 'arena-product-brand__logo';
      image.src = match.url;
      image.alt = match.name;
      image.loading = 'lazy';
      image.width = Number(match.width) || 150;
      image.height = 50;
      image.style.maxWidth = `${Number(match.width) || 150}px`;
      image.style.width = 'auto';
      image.style.height = 'auto';
      image.style.objectFit = 'contain';
    });
  }

  const refresh = () => applyLogos(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:block:select', refresh);
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) refresh();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
